import { Alert } from 'antd'
import { DISCLAIMER_MESSAGES } from '../../data'

export const DisclaimerAlert = () => {
  return (
    <div className='flex flex-col gap-4 mb-4'>
      {DISCLAIMER_MESSAGES.longDisclaimer.map((message, index) => (
        <Alert
          key={index}
          message={message}
          type='info'
          closable
          showIcon
          className='alert-custom-icon'
        />
      ))}
    </div>
  )
}

export default DisclaimerAlert
